var _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoHWhite = function SvgLogoHWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.8963,
    y: 26.5484,
    width: 32.2166,
    height: 90,
    fill: "#f1a91d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1129,
    y: 26.5484,
    width: 31.5334,
    height: 90,
    fill: "#f1a91d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26.613 131.548 11.613 131.548 11.613 116.548 15.363 116.548 15.363 127.798 26.613 127.798 26.613 131.548",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.613 26.548 11.613 11.548 26.613 11.548 26.613 15.298 15.363 15.298 15.363 26.548 11.613 26.548",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.613 26.548 131.613 11.548 116.613 11.548 116.613 15.298 127.863 15.298 127.863 26.548 131.613 26.548",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.613 116.548 131.613 131.548 116.613 131.548 116.613 127.798 127.863 127.798 127.863 116.548 131.613 116.548",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3294,
    y: 66.5298,
    width: 100.5669,
    height: 8.7685,
    fill: "#fcd479"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoHWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoHWhite.5a83aa649e919916234f6f3519834e9d.svg";